
module.exports = {
    /**
     * 推送页面类型
     */
    // 贷超页
    push_page_1: 1,
    // 企微页
    push_page_2: 2,

    /**
     * 渠道类型
     */
    // 全流程
    half_type_1: 1,
    // 半流程
    half_type_2: 2,
    // 大联登
    half_type_3: 3,
    // 联登
    half_type_4: 4,
    // 企微
    half_type_5: 5,

    page_code: {
        230: 'home_assessment',
    },


}